var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page-full-page', {
    staticClass: "app--main"
  }, [_c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.options,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "fullpage-section fullpage-section--visual"
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("세계를 무대로")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("세일즈&구독대행 서비스를")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("선도합니다.")])])])]), !!_vm.mainVisual1Url ? _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual1Url,
    staticClass: "swiper-slide__bg__video",
    attrs: {
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual1Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])]) : _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual1Url,
    staticClass: "swiper-slide__bg__video swiper-slide__bg__image",
    attrs: {
      "playsinline": "",
      "muted": "",
      "poster": _vm.mainVisual1Poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual1Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("맞춤형 대면 서비스로")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("영업의 한계를 넘습니다.")])])])]), !!_vm.mainVisual2Url ? _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual2Url,
    staticClass: "swiper-slide__bg__video",
    attrs: {
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual2Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])]) : _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual2Url,
    staticClass: "swiper-slide__bg__video swiper-slide__bg__image",
    attrs: {
      "playsinline": "",
      "muted": "",
      "poster": _vm.mainVisual2Poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual2Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("공감을 통해")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("브랜드 경험을 선사합니다.")])])])]), !!_vm.mainVisual3Url ? _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual3Url,
    staticClass: "swiper-slide__bg__video",
    attrs: {
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual3Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])]) : _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual3Url,
    staticClass: "swiper-slide__bg__video swiper-slide__bg__image",
    attrs: {
      "playsinline": "",
      "muted": "",
      "poster": _vm.mainVisual3Poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual3Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("진심을 통해")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("마음을 모으고 움직입니다.")])])])]), !!_vm.mainVisual4Url ? _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual4Url,
    staticClass: "swiper-slide__bg__video",
    attrs: {
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual4Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])]) : _c('div', {
    staticClass: "swiper-slide__bg"
  }, [_c('video', {
    key: _vm.mainVisual4Url,
    staticClass: "swiper-slide__bg__video swiper-slide__bg__image",
    attrs: {
      "playsinline": "",
      "muted": "",
      "poster": _vm.mainVisual4Poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.mainVisual4Url,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])])])]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "visual-pagination"
  })])])])]), _c('div', {
    staticClass: "fullpage-section fullpage-section--services"
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-tit text-center mb-50"
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-60 font-weight-bold color-white line-height-1",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" Our Services ")]), _c('p', {
    staticClass: "color-grey-d mt-8 mt-lg-20 font-size-14 font-size-lg-18",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 영업 실적은 물론, 브랜드의 가치까지 전달합니다. ")])]), _c('div', {
    staticClass: "service-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('v-btn', {
    staticClass: "slide-btn slide-btn-next",
    attrs: {
      "x-large": "",
      "icon": "",
      "outlined": "",
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })]), _c('v-btn', {
    staticClass: "slide-btn slide-btn-prev",
    attrs: {
      "x-large": "",
      "icon": "",
      "outlined": "",
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "service-item-wrap"
  }, [_c('div', {
    staticClass: "service-item"
  }, [_c('div', {
    staticClass: "service-item-inner"
  }, [_c('div', {
    staticClass: "service-item__top"
  }, [_c('h4', {
    staticClass: "font-weight-bold line-height-1"
  }, [_vm._v(" Commercial ")]), _c('p', [_vm._v(" 대면 영업을 통해 국내외 제품을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 홍보하고 판매합니다. ")])]), _c('div', {
    staticClass: "service-item__icon"
  }, [_c('div', {
    staticClass: "service-item__icon-wrap"
  }, [_c('img', {
    staticClass: "d-block icon-view",
    attrs: {
      "src": "/images/main/service-icon1.svg",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "d-block icon-hover",
    attrs: {
      "src": "/images/main/service-icon1-on.svg",
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "service-item__bottom"
  }, [_c('p', [_vm._v(" 영업 전문가인 브랜드 홍보대사의 대면 영업을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 통해 잠재고객 한 명 한 명에게 맞춤형 홍보 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 판매가 가능합니다. ")])])])])])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "service-item-wrap"
  }, [_c('div', {
    staticClass: "service-item"
  }, [_c('div', {
    staticClass: "service-item-inner"
  }, [_c('div', {
    staticClass: "service-item__top"
  }, [_c('h4', {
    staticClass: "font-weight-bold line-height-1"
  }, [_vm._v(" Subscription ")]), _c('p', [_vm._v(" 고객사의 서비스를 홍보하고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 구독자를 확보합니다. ")])]), _c('div', {
    staticClass: "service-item__icon"
  }, [_c('div', {
    staticClass: "service-item__icon-wrap"
  }, [_c('img', {
    staticClass: "d-block icon-view",
    attrs: {
      "src": "/images/main/service-icon2.svg",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "d-block icon-hover",
    attrs: {
      "src": "/images/main/service-icon2-on.svg",
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "service-item__bottom"
  }, [_c('p', [_vm._v(" 다양한 국가에서 25년 이상 축적한 경험과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 노하우를 바탕으로 구독 서비스 홍보, 구독자 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 확보를 전문적으로 대행합니다. ")])])])])])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "service-item-wrap"
  }, [_c('div', {
    staticClass: "service-item"
  }, [_c('div', {
    staticClass: "service-item-inner"
  }, [_c('div', {
    staticClass: "service-item__top"
  }, [_c('h4', {
    staticClass: "font-weight-bold line-height-1"
  }, [_vm._v(" Fundraising ")]), _c('p', [_vm._v(" NGO 단체 후원자를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 유치합니다. ")])]), _c('div', {
    staticClass: "service-item__icon"
  }, [_c('div', {
    staticClass: "service-item__icon-wrap"
  }, [_c('img', {
    staticClass: "d-block icon-view",
    attrs: {
      "src": "/images/main/service-icon3.svg",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "d-block icon-hover",
    attrs: {
      "src": "/images/main/service-icon3-on.svg",
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "service-item__bottom"
  }, [_c('p', [_vm._v(" 펀드레이징 전문 브랜드인 서포트웍스를 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전문 펀드레이저와 함께 NGO의 가치와 의미를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전달하고 후원자를 유치합니다. ")])])])])])])])], 1)])])], 1)]), _c('div', {
    staticClass: "fullpage-section fullpage-section--company"
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "mb-38 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 mb-8 mb-lg-22"
  }, [_vm._v(" SalesWorks Korea ")]), _c('h4', {
    staticClass: "font-size-22 font-size-lg-36 font-weight-bold line-height-13"
  }, [_vm._v(" 함께, 더 멀리 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 모두를 위한 기회를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 만듭니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('v-row', {
    staticClass: "pl-xl-42 pt-lg-48",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "icon-img-box-wrap w-100",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "icon-img-box"
  }, [_c('v-img', {
    staticClass: "icon-img-box__icon icon-img-box__icon--on",
    attrs: {
      "src": "/images/main/company-icon1.svg",
      "max-width": "48"
    }
  }), _c('v-img', {
    staticClass: "d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark",
    attrs: {
      "src": "/images/main/company-icon1-dark.svg",
      "max-width": "48"
    }
  }), _c('div', {
    staticClass: "image w-100"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/company-img1.png",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "count-txt mt-n34 px-16 px-md-26 w-100 text-right"
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10"
  }, [_vm._v(" 1995 ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 설립 ")])])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "icon-img-box-wrap w-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "icon-img-box"
  }, [_c('v-img', {
    staticClass: "icon-img-box__icon icon-img-box__icon--on",
    attrs: {
      "src": "/images/main/company-icon2.svg",
      "max-width": "48"
    }
  }), _c('v-img', {
    staticClass: "d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark",
    attrs: {
      "src": "/images/main/company-icon2-dark.svg",
      "max-width": "48"
    }
  }), _c('div', {
    staticClass: "image w-100"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/company-img2.png",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "count-txt mt-n34 px-16 px-md-26 w-100 text-right"
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10"
  }, [_vm._v(" 8+ ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 해외지사 ")])])])]), _c('v-col', {
    staticClass: "mt-18 mt-sm-0",
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "icon-img-box-wrap w-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "icon-img-box"
  }, [_c('v-img', {
    staticClass: "icon-img-box__icon icon-img-box__icon--on",
    attrs: {
      "src": "/images/main/company-icon3.svg",
      "max-width": "37"
    }
  }), _c('v-img', {
    staticClass: "d-none d-lg-block icon-img-box__icon icon-img-box__icon--dark",
    attrs: {
      "src": "/images/main/company-icon3-dark.svg",
      "max-width": "37"
    }
  }), _c('div', {
    staticClass: "image w-100"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/company-img3.png",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "count-txt mt-n34 px-16 px-md-26 w-100 text-right"
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-60 line-height-1 font-weight-bold color-point mb-6 mb-lg-10"
  }, [_vm._v(" 10+ ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 국내지사 ")])])])])], 1)], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "fullpage-section fullpage-section--client"
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('h4', {
    staticClass: "mb-50 mb-lg-84 font-size-22 font-size-lg-36 font-weight-thin line-height-13 color-white text-center"
  }, [_vm._v(" 다양한 글로벌 기업들이 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스의 서비스를 경험")]), _vm._v("하였습니다. ")]), _c('div', {
    staticClass: "mb-40 mb-lg-84"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-center px-16",
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 고객사 ")]), _c('h2', {
    staticClass: "color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 150+ ")])]), _c('v-col', {
    staticClass: "text-center px-16",
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 브랜드 홍보대사 ")]), _c('h2', {
    staticClass: "color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 4300+ ")])]), _c('v-col', {
    staticClass: "text-center px-16 mt-18 mt-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "color-white font-weight-bold font-size-18 font-size-lg-22 mb-12 mb-lg-30",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 펀드레이저 ")]), _c('h2', {
    staticClass: "color-point font-size-40 font-size-md-54 font-size-lg-80 line-height-1",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 2800+ ")])])], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    staticClass: "banner-link",
    attrs: {
      "href": "/ambassador"
    }
  }, [_c('div', {
    staticClass: "banner-link-inner d-flex flex-column justify-center px-20 px-md-40 px-xl-60",
    staticStyle: {
      "background-image": "url(/images/main/client-img1.png)"
    }
  }, [_c('h4', {
    staticClass: "mb-8 mb-lg-18 font-size-22 font-size-lg-36 font-weight-bold line-height-1 color-point"
  }, [_vm._v(" 브랜드 홍보대사 ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 최고의 브랜드 경험을 선사하는 "), _c('br'), _vm._v(" 브랜드 홍보대사 알아보기 ")])]), _c('div', {
    staticClass: "banner-link-button-wrap"
  }, [_c('button', {
    staticClass: "banner-link-button"
  }, [_c('span')])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    staticClass: "banner-link banner-link--mint",
    attrs: {
      "href": "/fund-laser"
    }
  }, [_c('div', {
    staticClass: "banner-link-inner d-flex flex-column justify-center px-20 px-md-40 px-xl-60",
    staticStyle: {
      "background-image": "url(/images/main/client-img2.png)"
    }
  }, [_c('h4', {
    staticClass: "mb-8 mb-lg-18 font-size-22 font-size-lg-36 font-weight-bold line-height-1 color-secondary"
  }, [_vm._v(" 펀드레이저 ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18"
  }, [_vm._v(" 같이의 가치를 전달하는 "), _c('br'), _vm._v(" 펀드레이저 알아보기 ")])]), _c('div', {
    staticClass: "banner-link-button-wrap"
  }, [_c('button', {
    staticClass: "banner-link-button banner-link-button-white"
  }, [_c('span')])])])])], 1)], 1)], 1)]), _c('div', {
    staticClass: "fullpage-section fullpage-section--vision"
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-lg-36 mb-38 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('v-img', {
    staticClass: "mb-20 mb-lg-54 w-120px w-lg-200px",
    attrs: {
      "src": "/images/supportworks-symbol.svg"
    }
  }), _c('h4', {
    staticClass: "color-white font-size-22 font-size-lg-36 font-weight-bold line-height-1 mb-8 mb-lg-18"
  }, [_vm._v(" 서포트웍스 ")]), _c('p', {
    staticClass: "color-grey-d font-size-14 font-size-lg-18"
  }, [_vm._v(" 서포트웍스는 글로벌 기업 세일즈웍스의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 펀드레이징 전문 브랜드입니다. ")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('div', {
    staticClass: "px-30 px-sm-0"
  }, [_c('v-row', {
    staticClass: "color-white",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mb-18 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "offset-md": "8",
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "box-link-wrap"
  }, [_c('div', {
    staticClass: "box-link box-link-border"
  }, [_c('div', {
    staticClass: "box-link-inner"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-lg-26 font-weight-bold line-height-14"
  }, [_vm._v(" 전문 펀드레이저의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 대면 모금 ")])]), _c('button', {
    staticClass: "box-link-button"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-14 mr-4 mr-lg-6"
  }, [_vm._v("More view")]), _c('span')])]), _c('div', {
    staticClass: "box-link-hover pa-20"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6"
  }, [_vm._v(" 전문 펀드레이저의 대면 모금 ")]), _c('p', {
    staticClass: "font-size-14 font-size-xl-18"
  }, [_vm._v(" 인성과 전문성, 책임감을 갖춘 펀드레이저의 캠페인 진행. "), _c('br'), _vm._v(" 1:1 대면 커뮤니케이션으로 NGO의 가치와 정확한 정보를 전달, 신뢰감을 형성 ")])])])]), _c('v-col', {
    staticClass: "mb-18 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-left",
      "data-aos-delay": "600"
    }
  }, [_c('div', {
    staticClass: "box-link-wrap"
  }, [_c('div', {
    staticClass: "box-link box-link-bg"
  }, [_c('div', {
    staticClass: "box-link-inner"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-lg-26 font-weight-bold line-height-14"
  }, [_vm._v(" 모금 캠페인 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 기획&컨설팅 ")])]), _c('button', {
    staticClass: "box-link-button"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-14 mr-4 mr-lg-6"
  }, [_vm._v("More view")]), _c('span')])]), _c('div', {
    staticClass: "box-link-hover pa-20"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6"
  }, [_vm._v(" 모금 캠페인 기획&컨설팅 ")]), _c('p', {
    staticClass: "font-size-14 font-size-xl-18"
  }, [_vm._v(" NGO 사업에 대한 깊은 이해를 바탕으로 효과적이고 전략적인 모금 캠페인을 기획 및 컨설팅하며 건강한 기부문화를 확산 ")])])])]), _c('v-col', {
    staticClass: "mb-18 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-left",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "box-link-wrap"
  }, [_c('div', {
    staticClass: "box-link box-link-border"
  }, [_c('div', {
    staticClass: "box-link-inner"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-lg-26 font-weight-bold line-height-14"
  }, [_vm._v(" 체계적인 통합 관리 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 프로세스 ")])]), _c('button', {
    staticClass: "box-link-button"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-14 mr-4 mr-lg-6"
  }, [_vm._v("More view")]), _c('span')])]), _c('div', {
    staticClass: "box-link-hover pa-20"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6"
  }, [_vm._v(" 체계적인 통합 관리 프로세스 ")]), _c('p', {
    staticClass: "font-size-14 font-size-xl-18"
  }, [_vm._v(" 데이터 관리 및 분석, 고객지원 등 전담 부서가 단계별로 서포트. "), _c('br'), _vm._v(" 캠페인의 시작부터 끝까지 전 과정을 체계적으로 분석 및 관리 ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-left",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "box-link-wrap"
  }, [_c('div', {
    staticClass: "box-link box-link-bg"
  }, [_c('div', {
    staticClass: "box-link-inner"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-lg-26 font-weight-bold line-height-14"
  }, [_vm._v(" 아시아 8개 국가의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 국제적 노하우 ")])]), _c('button', {
    staticClass: "box-link-button"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-14 mr-4 mr-lg-6"
  }, [_vm._v("More view")]), _c('span')])]), _c('div', {
    staticClass: "box-link-hover pa-20"
  }, [_c('h4', {
    staticClass: "font-size-18 font-size-xl-22 font-weight-bold line-height-14 mb-6"
  }, [_vm._v(" 아시아 8개 국가의 국제적 노하우 ")]), _c('p', {
    staticClass: "font-size-14 font-size-xl-18"
  }, [_vm._v(" 아시아 전역 다양한 국가의 NGO 단체 경험과 25년 이상의 누적 데이터 보유. "), _c('br'), _vm._v(" 8개국 지사가 공유하는 펀드레이징 교육과정과 체계적인 모금 관리 시스템 ")])])])])], 1)], 1)])], 1)], 1)], 1)]), _c('div', {
    staticClass: "fullpage-section fullpage-section--live"
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-20 mb-lg-60"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "mb-50"
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-60 font-weight-bold line-height-1",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 세일즈웍스 "), _c('span', {
    staticClass: "color-point"
  }, [_vm._v("LIVE")])]), _c('p', {
    staticClass: "color-grey-3 mt-8 mt-lg-20 font-size-14 font-size-lg-18",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 세일즈웍스의 다양한 소식을 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" SNS를 통해 만나보세요. ")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('a', {
    staticClass: "sns sns--blog mr-6 mr-lg-12",
    attrs: {
      "href": "https://blog.naver.com/salesworkskorea",
      "target": "_blank"
    }
  }), _c('a', {
    staticClass: "sns sns--instar mr-6 mr-lg-12",
    attrs: {
      "href": "https://www.instagram.com/salesworkskorea",
      "target": "_blank"
    }
  }), _c('a', {
    staticClass: "sns sns--youtube mr-6 mr-lg-12",
    attrs: {
      "href": "https://www.youtube.com/c/salesworkskorea",
      "target": "_blank"
    }
  }), _c('a', {
    staticClass: "sns sns--facebook",
    attrs: {
      "href": "https://www.facebook.com/salesworkskr",
      "target": "_blank"
    }
  })])]), _c('v-col', {
    staticClass: "mt-18 mt-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "video-wrap"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    }
  })], 1)])], 1)], 1), _c('div', {
    staticClass: "row justify-center row-cols-3 row-cols-md-5 ma-n6 ma-lg-n18"
  }, _vm._l(_vm.mainImgs, function (img, idx) {
    return _c('div', {
      key: idx,
      staticClass: "pa-6 pa-lg-18"
    }, [_c('div', {
      staticClass: "live-thum-wrap"
    }, [_c('div', {
      staticClass: "live-thum",
      staticStyle: {}
    }, [_c('a', {
      attrs: {
        "href": img.meta.href,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "src": img === null || img === void 0 ? void 0 : img.thumb
      }
    })], 1)])])]);
  }), 0)])], 1)]), _c('main-footer', {
    staticClass: "fullpage-section fp-auto-height"
  })], 1), _c('u-scroll-top-full-page'), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }